import { SELECT_DIALING_PLAN, UPDATE_ADD_ON_FEATURES, 
    UPDATE_DIALING_PLAN_QUANTITY, SET_DIALING_PLAN } from '../actions/DialingPlansActions'

const initialState = {
    DialingPlan: {
        id: "UNLIMITED", //"PAY_AS_YOU_GO",
        isUnlimited: true,
        quantity: "",
        price: 24.99,
    },
    AddOnFeatures: []
}

const DilaingPlanReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_DIALING_PLAN:
            return {
                ...state,
                DialingPlan: action.newDialingPlanData
            }
        case SELECT_DIALING_PLAN:
            return {
                ...state,
                DialingPlan: {
                    id: action.planId,
                    isUnlimited: action.isUnlimited,
                    quantity: "",
                    price: action.planPrice
                }
            }
        case UPDATE_DIALING_PLAN_QUANTITY:
            return {
                ...state,
                DialingPlan: {
                    ...state.DialingPlan,
                    quantity: action.newQty,
                }
            }
        case UPDATE_ADD_ON_FEATURES:
            return {
                ...state,
                AddOnFeatures: action.AddOnFeatures,
            }
        default:
            return state;
    }
}

export default DilaingPlanReducer;